<template>
  <div class="clients">
    <div class="clients__body">
      <a>
        <div class="sort_type">
          <label for="sort_type">Сортировать по</label>
          <select id="sort_type" v-model="sortType">
            <option value="register_date">Дата регистрации</option>
            <option value="last_visit">Последнее посещение</option>
          </select>
        </div>
        <transition-group name="slide-fade">
          <div
              class="clients__item"
              :class="{active: clientsItem.isActive}"
              :key="idx" v-for="(clientsItem, idx) in filteredClients"
              @click="clientsItemClick(clientsItem)"
          >
            <div class="clients__item-logo">
              <img :src="clientsItem.client.avatar" alt="" height="50px" width="50px" style="border-radius: 50%;border: 1px solid #DBBFA7;object-fit: cover;">
            </div>
            <div class="clients__item-top">
              <div class="clients__item-top-user">
                <div>
                  <div class="clients__item-fullname">{{ clientsItem.client.full_name }}</div>
                </div>
                <div>
                  <div class="clients__item-date">{{ clientsItem.created_at }}</div>
                </div>
              </div>
              <div class="clients__item-body">
                <p>{{ clientsItem.client.phone }}</p>
              </div>
            </div>
          </div>
        </transition-group>
        <div v-if="!clients.length">
          <h4 style="text-align: center;margin-top: 20px;color: #38383885">Список пуст</h4>
        </div>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ClientsPreview',
  props: {
    clients: Array,
  },
  data: () => ({
    sortType: 'register_date'
  }),
  computed: {
    filteredClients() {
      const clonedClients = [...this.clients]

      return clonedClients.sort((a,b) => {
        let aDate = Date.parse(a.client.created_at)
        let bDate = Date.parse(b.client.created_at)

        if (this.sortType === 'last_visit') {
          aDate = Date.parse(a.updated_at)
          bDate = Date.parse(b.updated_at)

          if ( aDate > bDate ) return -1
          if ( aDate < bDate ) return 1
          return 0
        }

        if ( aDate < bDate ) return -1
        if ( aDate > bDate ) return 1
        return 0
      })
    }
  },
  methods: {
    clientsItemClick(clientsItem) {
      const idx = this.clients.findIndex(client => client.id === clientsItem.id)
      this.$emit('click', idx)
    }
  }
}
</script>
<style scoped lang="scss">
.clients {
  background-color: #fff;
  padding: 0 0;
}

.clients__item {
  padding: 10px 15px;
  border-bottom: 1px solid #E5E5E5;
  display: flex;

  &.active {
    color: #383838;
    background-color: rgba(219, 191, 167, 0.3);

    &:hover {
      opacity: 1;
    }
  }

  &-top {
    width: 100%;
    &-user {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }

  &-fullname {
    font-weight: 600;
    font-size: 16px;
    color: #383838;
  }

  &-date {
    line-height: 24px;
    font-size: 14px;
    color: #808080;
  }

  &-logo {
    border: 1px solid #DBBFA7;
    border-radius: 50%;
    width: 50px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 10px;
  }

  &-body {
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 24px;
    color: #808080;

    p {
      width: 100%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}

.slide-fade-enter-active {
  transition: all 0.3s ease;
}

.slide-fade-leave-active {
  transition: all 0.3s ease;
}

.slide-fade-enter, .slide-fade-leave-to {
  transform: translateX(10px);
  opacity: 0;
}

@media screen and (max-width: 1170px) {
  .clients__item-date {
    display: none;
  }
}

.sort_type {
  margin-left: 20px;
  margin-bottom: 20px;
  label {
    font-size: 16px;
    display: block;
    margin-bottom: 5px;
  }
  select {
    position: relative;
    border: 1px solid #DBBFA7;
    box-sizing: border-box;
    border-radius: 5px;
    height: 30px;
    cursor: pointer;
    padding-left: 10px;
    padding-right: 10px;
    background-color: transparent;
    font-size: 16px;
    color: #383838;
    z-index: 2;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    font-family: "Open Sans", sans-serif;
  }
}
</style>
